export default __webpack_public_path__ + "static/media/hain.4d670a4c.svg";